/**
 * @fileoverview gRPC-Web generated client stub for api
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: api/fuota.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_api_annotations_pb = require('../google/api/annotations_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var common_common_pb = require('../common/common_pb.js')

var api_multicast_group_pb = require('../api/multicast_group_pb.js')
const proto = {};
proto.api = require('./fuota_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.FuotaServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.api.FuotaServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.CreateFuotaDeploymentRequest,
 *   !proto.api.CreateFuotaDeploymentResponse>}
 */
const methodDescriptor_FuotaService_CreateDeployment = new grpc.web.MethodDescriptor(
  '/api.FuotaService/CreateDeployment',
  grpc.web.MethodType.UNARY,
  proto.api.CreateFuotaDeploymentRequest,
  proto.api.CreateFuotaDeploymentResponse,
  /**
   * @param {!proto.api.CreateFuotaDeploymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.CreateFuotaDeploymentResponse.deserializeBinary
);


/**
 * @param {!proto.api.CreateFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.CreateFuotaDeploymentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.CreateFuotaDeploymentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.FuotaServiceClient.prototype.createDeployment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.FuotaService/CreateDeployment',
      request,
      metadata || {},
      methodDescriptor_FuotaService_CreateDeployment,
      callback);
};


/**
 * @param {!proto.api.CreateFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.CreateFuotaDeploymentResponse>}
 *     Promise that resolves to the response
 */
proto.api.FuotaServicePromiseClient.prototype.createDeployment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.FuotaService/CreateDeployment',
      request,
      metadata || {},
      methodDescriptor_FuotaService_CreateDeployment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.GetFuotaDeploymentRequest,
 *   !proto.api.GetFuotaDeploymentResponse>}
 */
const methodDescriptor_FuotaService_GetDeployment = new grpc.web.MethodDescriptor(
  '/api.FuotaService/GetDeployment',
  grpc.web.MethodType.UNARY,
  proto.api.GetFuotaDeploymentRequest,
  proto.api.GetFuotaDeploymentResponse,
  /**
   * @param {!proto.api.GetFuotaDeploymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.GetFuotaDeploymentResponse.deserializeBinary
);


/**
 * @param {!proto.api.GetFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.GetFuotaDeploymentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.GetFuotaDeploymentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.FuotaServiceClient.prototype.getDeployment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.FuotaService/GetDeployment',
      request,
      metadata || {},
      methodDescriptor_FuotaService_GetDeployment,
      callback);
};


/**
 * @param {!proto.api.GetFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.GetFuotaDeploymentResponse>}
 *     Promise that resolves to the response
 */
proto.api.FuotaServicePromiseClient.prototype.getDeployment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.FuotaService/GetDeployment',
      request,
      metadata || {},
      methodDescriptor_FuotaService_GetDeployment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.UpdateFuotaDeploymentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_FuotaService_UpdateDeployment = new grpc.web.MethodDescriptor(
  '/api.FuotaService/UpdateDeployment',
  grpc.web.MethodType.UNARY,
  proto.api.UpdateFuotaDeploymentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.api.UpdateFuotaDeploymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.api.UpdateFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.FuotaServiceClient.prototype.updateDeployment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.FuotaService/UpdateDeployment',
      request,
      metadata || {},
      methodDescriptor_FuotaService_UpdateDeployment,
      callback);
};


/**
 * @param {!proto.api.UpdateFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.api.FuotaServicePromiseClient.prototype.updateDeployment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.FuotaService/UpdateDeployment',
      request,
      metadata || {},
      methodDescriptor_FuotaService_UpdateDeployment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.DeleteFuotaDeploymentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_FuotaService_DeleteDeployment = new grpc.web.MethodDescriptor(
  '/api.FuotaService/DeleteDeployment',
  grpc.web.MethodType.UNARY,
  proto.api.DeleteFuotaDeploymentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.api.DeleteFuotaDeploymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.api.DeleteFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.FuotaServiceClient.prototype.deleteDeployment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.FuotaService/DeleteDeployment',
      request,
      metadata || {},
      methodDescriptor_FuotaService_DeleteDeployment,
      callback);
};


/**
 * @param {!proto.api.DeleteFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.api.FuotaServicePromiseClient.prototype.deleteDeployment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.FuotaService/DeleteDeployment',
      request,
      metadata || {},
      methodDescriptor_FuotaService_DeleteDeployment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.StartFuotaDeploymentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_FuotaService_StartDeployment = new grpc.web.MethodDescriptor(
  '/api.FuotaService/StartDeployment',
  grpc.web.MethodType.UNARY,
  proto.api.StartFuotaDeploymentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.api.StartFuotaDeploymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.api.StartFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.FuotaServiceClient.prototype.startDeployment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.FuotaService/StartDeployment',
      request,
      metadata || {},
      methodDescriptor_FuotaService_StartDeployment,
      callback);
};


/**
 * @param {!proto.api.StartFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.api.FuotaServicePromiseClient.prototype.startDeployment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.FuotaService/StartDeployment',
      request,
      metadata || {},
      methodDescriptor_FuotaService_StartDeployment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListFuotaDeploymentsRequest,
 *   !proto.api.ListFuotaDeploymentsResponse>}
 */
const methodDescriptor_FuotaService_ListDeployments = new grpc.web.MethodDescriptor(
  '/api.FuotaService/ListDeployments',
  grpc.web.MethodType.UNARY,
  proto.api.ListFuotaDeploymentsRequest,
  proto.api.ListFuotaDeploymentsResponse,
  /**
   * @param {!proto.api.ListFuotaDeploymentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListFuotaDeploymentsResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListFuotaDeploymentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListFuotaDeploymentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListFuotaDeploymentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.FuotaServiceClient.prototype.listDeployments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.FuotaService/ListDeployments',
      request,
      metadata || {},
      methodDescriptor_FuotaService_ListDeployments,
      callback);
};


/**
 * @param {!proto.api.ListFuotaDeploymentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListFuotaDeploymentsResponse>}
 *     Promise that resolves to the response
 */
proto.api.FuotaServicePromiseClient.prototype.listDeployments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.FuotaService/ListDeployments',
      request,
      metadata || {},
      methodDescriptor_FuotaService_ListDeployments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.AddDevicesToFuotaDeploymentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_FuotaService_AddDevices = new grpc.web.MethodDescriptor(
  '/api.FuotaService/AddDevices',
  grpc.web.MethodType.UNARY,
  proto.api.AddDevicesToFuotaDeploymentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.api.AddDevicesToFuotaDeploymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.api.AddDevicesToFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.FuotaServiceClient.prototype.addDevices =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.FuotaService/AddDevices',
      request,
      metadata || {},
      methodDescriptor_FuotaService_AddDevices,
      callback);
};


/**
 * @param {!proto.api.AddDevicesToFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.api.FuotaServicePromiseClient.prototype.addDevices =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.FuotaService/AddDevices',
      request,
      metadata || {},
      methodDescriptor_FuotaService_AddDevices);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.RemoveDevicesFromFuotaDeploymentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_FuotaService_RemoveDevices = new grpc.web.MethodDescriptor(
  '/api.FuotaService/RemoveDevices',
  grpc.web.MethodType.UNARY,
  proto.api.RemoveDevicesFromFuotaDeploymentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.api.RemoveDevicesFromFuotaDeploymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.api.RemoveDevicesFromFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.FuotaServiceClient.prototype.removeDevices =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.FuotaService/RemoveDevices',
      request,
      metadata || {},
      methodDescriptor_FuotaService_RemoveDevices,
      callback);
};


/**
 * @param {!proto.api.RemoveDevicesFromFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.api.FuotaServicePromiseClient.prototype.removeDevices =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.FuotaService/RemoveDevices',
      request,
      metadata || {},
      methodDescriptor_FuotaService_RemoveDevices);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListFuotaDeploymentDevicesRequest,
 *   !proto.api.ListFuotaDeploymentDevicesResponse>}
 */
const methodDescriptor_FuotaService_ListDevices = new grpc.web.MethodDescriptor(
  '/api.FuotaService/ListDevices',
  grpc.web.MethodType.UNARY,
  proto.api.ListFuotaDeploymentDevicesRequest,
  proto.api.ListFuotaDeploymentDevicesResponse,
  /**
   * @param {!proto.api.ListFuotaDeploymentDevicesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListFuotaDeploymentDevicesResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListFuotaDeploymentDevicesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListFuotaDeploymentDevicesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListFuotaDeploymentDevicesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.FuotaServiceClient.prototype.listDevices =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.FuotaService/ListDevices',
      request,
      metadata || {},
      methodDescriptor_FuotaService_ListDevices,
      callback);
};


/**
 * @param {!proto.api.ListFuotaDeploymentDevicesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListFuotaDeploymentDevicesResponse>}
 *     Promise that resolves to the response
 */
proto.api.FuotaServicePromiseClient.prototype.listDevices =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.FuotaService/ListDevices',
      request,
      metadata || {},
      methodDescriptor_FuotaService_ListDevices);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.AddGatewaysToFuotaDeploymentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_FuotaService_AddGateways = new grpc.web.MethodDescriptor(
  '/api.FuotaService/AddGateways',
  grpc.web.MethodType.UNARY,
  proto.api.AddGatewaysToFuotaDeploymentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.api.AddGatewaysToFuotaDeploymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.api.AddGatewaysToFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.FuotaServiceClient.prototype.addGateways =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.FuotaService/AddGateways',
      request,
      metadata || {},
      methodDescriptor_FuotaService_AddGateways,
      callback);
};


/**
 * @param {!proto.api.AddGatewaysToFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.api.FuotaServicePromiseClient.prototype.addGateways =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.FuotaService/AddGateways',
      request,
      metadata || {},
      methodDescriptor_FuotaService_AddGateways);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListFuotaDeploymentGatewaysRequest,
 *   !proto.api.ListFuotaDeploymentGatewaysResponse>}
 */
const methodDescriptor_FuotaService_ListGateways = new grpc.web.MethodDescriptor(
  '/api.FuotaService/ListGateways',
  grpc.web.MethodType.UNARY,
  proto.api.ListFuotaDeploymentGatewaysRequest,
  proto.api.ListFuotaDeploymentGatewaysResponse,
  /**
   * @param {!proto.api.ListFuotaDeploymentGatewaysRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListFuotaDeploymentGatewaysResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListFuotaDeploymentGatewaysRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListFuotaDeploymentGatewaysResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListFuotaDeploymentGatewaysResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.FuotaServiceClient.prototype.listGateways =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.FuotaService/ListGateways',
      request,
      metadata || {},
      methodDescriptor_FuotaService_ListGateways,
      callback);
};


/**
 * @param {!proto.api.ListFuotaDeploymentGatewaysRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListFuotaDeploymentGatewaysResponse>}
 *     Promise that resolves to the response
 */
proto.api.FuotaServicePromiseClient.prototype.listGateways =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.FuotaService/ListGateways',
      request,
      metadata || {},
      methodDescriptor_FuotaService_ListGateways);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.RemoveGatewaysFromFuotaDeploymentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_FuotaService_RemoveGateways = new grpc.web.MethodDescriptor(
  '/api.FuotaService/RemoveGateways',
  grpc.web.MethodType.UNARY,
  proto.api.RemoveGatewaysFromFuotaDeploymentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.api.RemoveGatewaysFromFuotaDeploymentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.api.RemoveGatewaysFromFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.FuotaServiceClient.prototype.removeGateways =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.FuotaService/RemoveGateways',
      request,
      metadata || {},
      methodDescriptor_FuotaService_RemoveGateways,
      callback);
};


/**
 * @param {!proto.api.RemoveGatewaysFromFuotaDeploymentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.api.FuotaServicePromiseClient.prototype.removeGateways =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.FuotaService/RemoveGateways',
      request,
      metadata || {},
      methodDescriptor_FuotaService_RemoveGateways);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.api.ListFuotaDeploymentJobsRequest,
 *   !proto.api.ListFuotaDeploymentJobsResponse>}
 */
const methodDescriptor_FuotaService_ListJobs = new grpc.web.MethodDescriptor(
  '/api.FuotaService/ListJobs',
  grpc.web.MethodType.UNARY,
  proto.api.ListFuotaDeploymentJobsRequest,
  proto.api.ListFuotaDeploymentJobsResponse,
  /**
   * @param {!proto.api.ListFuotaDeploymentJobsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.api.ListFuotaDeploymentJobsResponse.deserializeBinary
);


/**
 * @param {!proto.api.ListFuotaDeploymentJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.api.ListFuotaDeploymentJobsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.api.ListFuotaDeploymentJobsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.api.FuotaServiceClient.prototype.listJobs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/api.FuotaService/ListJobs',
      request,
      metadata || {},
      methodDescriptor_FuotaService_ListJobs,
      callback);
};


/**
 * @param {!proto.api.ListFuotaDeploymentJobsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.api.ListFuotaDeploymentJobsResponse>}
 *     Promise that resolves to the response
 */
proto.api.FuotaServicePromiseClient.prototype.listJobs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/api.FuotaService/ListJobs',
      request,
      metadata || {},
      methodDescriptor_FuotaService_ListJobs);
};


module.exports = proto.api;

